import { type CityProfile } from '@core/city-profile/city-profile'

// the Lisbon demo profile — scalar identity / map anchors only for now.
// the POI, overlay and DB datasets are added in a later phase ; until then the
// demolisbon build re-centres the map on Lisbon but still shows the Lyon dataset.
export const kLisbonProfile: CityProfile = {
  id: 'lisbon',
  displayName: 'Mobilidade Lisboa',
  brandLines: ['Mobilidade', 'Lisboa'],
  center: [-9.1393, 38.7223],
  zoom: 13.2,
  supervisionZoom: 12.5,
  locale: 'pt-pt',
  tz: 'Europe/Lisbon',
}
